export default __webpack_public_path__ + "static/media/meet.55dd15ee.svg";